import AuthLoading from '../screens/AuthScreen/AuthLoadingScreen';
import ForgotPasswordScreen from '../screens/AuthScreen/ForgotPasswordScreen';
import SignInScreen from '../screens/AuthScreen/SignInScreen';
import SignUpScreen from '../screens/AuthScreen/SignUpScreen';
import StudentDetailsScreen from '../screens/AuthScreen/StudentDetails';
import WelcomeScreen from '../screens/AuthScreen/WelcomeScreen';
import ConfigurePackage from '../screens/ConfigurePackage';
import ContactUs from '../screens/ContactUs';
import MainPage from '../screens/MainScreen';
import ClassroomPage from '../screens/MainScreen/Classroom';
import HomePage from '../screens/MainScreen/Home';
import InboxPage from '../screens/MainScreen/Inbox';
import SubjectsPage from '../screens/MainScreen/Subjects';
import SubscriptionPage from '../screens/MainScreen/Subscription';
import TimeTablePage from '../screens/MainScreen/TimeTable';
import PackageDetails from '../screens/PackageDetails';
import PackagePurchaseSummary from '../screens/PackagePurchaseSummary';
import Payment from '../screens/Payment';
import PaymentHistory from '../screens/PaymentHistory';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import SelectTimeTable from '../screens/SelectTimeTable';
import SettingsPage from '../screens/Settings';
import StudentRegistration from '../screens/StudentRegistration';
import SubjectDetails from '../screens/SubjectDetails';
import TermsOfServices from '../screens/TermsOfServices';
import VideoHelpPage from '../screens/VideoHelpPage';

const contactUs = {
  path: 'contactUs',
  component: ContactUs,
};

export const UN_AUTHENTICATED_ROUTES = {
  welcomeScreen: {
    path: 'welcomeScreen',
    component: WelcomeScreen,
  },
  authLoading: {
    path: 'authLoading',
    component: AuthLoading,
  },
  signIn: {
    path: 'signIn',
    component: SignInScreen,
  },
  signUp: {
    path: 'signUp',
    component: SignUpScreen,
  },
  forgotPassword: {
    path: 'forgotPassword',
    component: ForgotPasswordScreen,
  },
  studentDetails: {
    path: 'studentDetails',
    component: StudentDetailsScreen,
  },
  privacyPolicy: {
    path: 'privacyPolicy',
    component: PrivacyPolicy,
  },
  termsOfServices: {
    path: 'termsOfServices',
    component: TermsOfServices,
  },
  contactUs,
};

export const AUTHENTICATED_ROUTES = {
  main: {
    path: 'main',
    component: MainPage,
  },
  subjectDetails: {
    path: 'subjectDetails',
    component: SubjectDetails,
  },
  packageDetails: {
    path: 'packageDetails',
    component: PackageDetails,
  },
  studentRegistration: {
    path: 'studentRegistration',
    component: StudentRegistration,
  },
  configurePackage: {
    path: 'configurePackage',
    component: ConfigurePackage,
  },
  selectTimeTable: {
    path: 'selectTimeTable',
    component: SelectTimeTable,
  },
  packagePurchaseSummary: {
    path: 'packagePurchaseSummary',
    component: PackagePurchaseSummary,
  },
  payment: {
    path: 'payment',
    component: Payment,
  },
};

export const DRAWER_ROUTES = {
  home: {
    path: 'home',
    component: HomePage,
  },
  classroom: {
    path: 'classroom',
    component: ClassroomPage,
  },
  inbox: {
    path: 'inbox',
    component: InboxPage,
  },
  subscription: {
    path: 'subscription',
    component: SubscriptionPage,
  },
  subjects: {
    path: 'subjects',
    component: SubjectsPage,
  },
  timeTable: {
    path: 'timeTable',
    component: TimeTablePage,
  },
  settings: {
    path: 'settings',
    component: SettingsPage,
  },
  paymentHistory: {
    path: 'paymentHistory',
    component: PaymentHistory,
  },
  videoHelpPage: {
    path: 'videoHelpPage',
    component: VideoHelpPage,
  },
  contactUs,
};
